import styled from "styled-components";
import { colors, font, radius, shadow } from "../../styles/theme/tokens";

export const Card = styled.section`
  margin-bottom: 20px;
  padding: 18px 20px;
  border-radius: ${radius.lg};
  font-family: ${font.text};
  color: ${colors.ink};
  background: ${colors.surface};
  box-shadow: ${shadow.card};

  @media (max-width: 480px) {
    padding: 16px;
  }
`;

export const Head = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
`;

export const Title = styled.h3`
  font-size: 18px;
  font-weight: 800;
`;

export const Progress = styled.span`
  font-size: 13px;
  font-weight: 700;
  color: ${colors.muted};
`;

export const Hide = styled.button`
  display: grid;
  place-items: center;
  flex-shrink: 0;
  width: 32px;
  height: 32px;
  border: none;
  border-radius: 50%;
  color: ${colors.muted};
  background: transparent;
  cursor: pointer;

  &:hover {
    background: ${colors.brandSoft};
  }
`;

export const Bar = styled.div`
  height: 6px;
  margin: 12px 0 8px;
  border-radius: ${radius.pill};
  background: ${colors.brandSoft};
  overflow: hidden;

  span {
    display: block;
    height: 100%;
    border-radius: inherit;
    background: ${colors.brand};
    transition: width 0.3s ease;
  }
`;

export const List = styled.ul`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
  list-style: none;

  @media (max-width: 640px) {
    grid-template-columns: 1fr;
  }
`;

export const Item = styled.button`
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  padding: 12px;
  border: 1px solid ${(props) => (props.$done ? "transparent" : colors.line)};
  border-radius: ${radius.md};
  font-family: ${font.text};
  text-align: left;
  color: ${colors.ink};
  background: ${(props) => (props.$done ? colors.successSoft : colors.surface)};
  cursor: ${(props) => (props.$done ? "default" : "pointer")};

  &:not(:disabled):hover {
    border-color: ${colors.brand};
  }

  .arrow {
    flex-shrink: 0;
    margin-left: auto;
    color: ${colors.muted};
  }
`;

export const Check = styled.span`
  display: grid;
  place-items: center;
  flex-shrink: 0;
  width: 26px;
  height: 26px;
  border-radius: 50%;
  border: 2px solid ${(props) => (props.$done ? colors.success : colors.line)};
  color: #FFFFFF;
  background: ${(props) => (props.$done ? colors.success : "transparent")};
`;

export const ItemText = styled.span`
  display: flex;
  flex-direction: column;
  min-width: 0;

  b {
    font-size: 15px;
    font-weight: 700;
  }

  small {
    font-size: 13px;
    color: ${colors.muted};
  }
`;
